
<wb-tooltip position="top" *ngIf="showDeleteButton">
  <wb-button variant="tertiary" size="s" (click)="deleteClicked()">
    <wb-icon
      name="bds/trash/24"
      class="icon-color"
      variant="primary"
      delete
    >
    </wb-icon>
  </wb-button>
  <div slot="content">Delete</div>
</wb-tooltip>
<wb-tooltip position="top" *ngIf="showAddFavButton">
  <wb-button variant="tertiary" size="s" style="margin-right: 0px;" (click)="addFavouriteClicked()">
  <wb-icon
          slot="icon"
          name="bds/star/24"
          style="color: rgb(174, 168, 168)"
          class="icon-color"
          variant="tertiary"
        ></wb-icon>
  </wb-button>

  <div slot="content"> Add Favourite</div>
</wb-tooltip>
<wb-tooltip position="top" *ngIf="showRemoveFavButton">
  <wb-button variant="tertiary" size="s" style="margin-right: 0px;" (click)="removeFavouriteClicked()" >
  <wb-icon
          slot="icon"
          name="bds/star/24"
         
          class="icon-color"
          variant="tertiary"          
        ></wb-icon>
  </wb-button>

  <div slot="content">Remove Favourite</div>
</wb-tooltip>
<!--     <wb-button-group-item variant="primary" size="l" icon-only><wb-icon slot="icon" flip-rtl name="bds/trash/24"></wb-icon>Delete</wb-button-group-item> -->
